var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "header-container" } },
    [
      _c("div", { staticClass: "system" }, [
        _c("img", {
          attrs: {
            src: require("../../../public/image/logo.png"),
            align: "absmiddle",
            title: _vm.thumb === 1 ? "展开菜单栏" : "折叠菜单栏",
          },
          on: { click: _vm.setThumb },
        }),
        _vm._v(" " + _vm._s(_vm.config.systemName) + " "),
      ]),
      _c("div", { staticClass: "toolbar" }, [
        _vm.loginShop?.shop_name
          ? _c("span", { staticStyle: { "padding-right": "20px" } }, [
              _vm._v(
                _vm._s(_vm.loginShop.shop_name) +
                  "（" +
                  _vm._s(_vm.loginShop.shop_extname) +
                  "）"
              ),
            ])
          : _vm._e(),
        _c("img", {
          staticStyle: { width: "25px", height: "25px" },
          attrs: {
            src: require("../../../public/image/avatar.png"),
            align: "absmiddle",
          },
        }),
        _vm._v("  " + _vm._s(_vm.user_name) + "    "),
        _c("img", {
          attrs: {
            src: require("../../../public/image/header_line.png"),
            align: "absmiddle",
          },
        }),
        _vm._v("    岗位  "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.officer_id,
                expression: "officer_id",
              },
            ],
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.officer_id = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _vm._l(_vm.officerList, function (item) {
              return [
                _c(
                  "option",
                  {
                    key: item.officer_id,
                    domProps: { value: item.officer_id },
                  },
                  [_vm._v(" " + _vm._s(item.officer_name) + " ")]
                ),
              ]
            }),
          ],
          2
        ),
        _vm._v("     "),
        _c("img", {
          attrs: {
            src: require("../../../public/image/home.png"),
            align: "absmiddle",
            title: "首页",
          },
        }),
        _vm._v("   "),
        _c("img", {
          attrs: {
            src: require("../../../public/image/password.png"),
            align: "absmiddle",
            title: "修改密码",
          },
          on: {
            click: function ($event) {
              _vm.dialog = true
            },
          },
        }),
        _vm._v("   "),
        _c("img", {
          attrs: {
            src: require("../../../public/image/exit.png"),
            title: "退出",
            align: "absmiddle",
          },
          on: { click: _vm.logout },
        }),
      ]),
      _c("div", { staticClass: "clear" }),
      _c("password-edit", {
        attrs: { show: _vm.dialog },
        on: { close: _vm.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }